/**
 * Generated With: pnpm x packages/api/tools/generate-shopify-rest-model.ts
 */

import { FieldType } from "../../type-system/FieldType";
import {
  ShopifyCheckoutKey,
  ShopifyCheckoutToShippingAddressKey,
  ShopifyShippingAddressKey,
  ShopifyShippingAddressToCheckoutsKey,
  ShopifyShippingAddressToShopKey,
  ShopifyShopKey,
} from "./keys";
import { ShopifyApiVersion } from "./ShopifyApiVersion";
import { ShopifyDominion } from "./ShopifyDominion";
import type { ConnectionModelSpecVersion } from "./ShopifyMetadata";
import { buildConnectionSpec } from "./ShopifyMetadata";

const specs: ConnectionModelSpecVersion = {
  key: ShopifyShippingAddressKey,
  "2022-01": {
    name: "Shopify Shipping Address",
    fields: [
      {
        name: "Address 1",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "address1" } },
      },
      {
        name: "Address 2",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "address2" } },
      },
      {
        name: "City",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "city" } },
      },
      {
        name: "Company",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "company" } },
      },
      {
        name: "Country",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "country" } },
      },
      {
        name: "Country Code",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "country_code" } },
      },
      {
        name: "First Name",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "first_name" } },
      },
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "id" } },
      },
      {
        name: "Last Name",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "last_name" } },
      },
      {
        name: "Phone",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "phone" } },
      },
      {
        name: "Province",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "province" } },
      },
      {
        name: "Province Code",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "province_code" } },
      },
      {
        name: "ZIP Code",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "zip" } },
      },
      {
        name: "Checkouts",
        fieldType: FieldType.HasMany,
        key: ShopifyShippingAddressToCheckoutsKey,
        configuration: {
          relatedModelKey: ShopifyCheckoutKey,
          inverseFieldKey: ShopifyCheckoutToShippingAddressKey,
        },
      },
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifyShippingAddressToShopKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "shop_id" } },
        configuration: {
          relatedModelKey: ShopifyShopKey,
        },
      },
    ],
    syncConfig: { type: "custom", resource: "checkout" },
  },
  "2025-04": {
    fields: [
      {
        name: "Address 1",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "address1", availableInWebhook: ["checkouts/create", "checkouts/update"] },
        },
      },
      {
        name: "Address 2",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "address2", availableInWebhook: ["checkouts/create", "checkouts/update"] },
        },
      },
      {
        name: "City",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "city", availableInWebhook: ["checkouts/create", "checkouts/update"] },
        },
      },
      {
        name: "Company",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "company", availableInWebhook: ["checkouts/create", "checkouts/update"] },
        },
      },
      {
        name: "Country",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "country", availableInWebhook: ["checkouts/create", "checkouts/update"] },
        },
      },
      {
        name: "Country Code",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "country_code", availableInWebhook: ["checkouts/create", "checkouts/update"] },
        },
      },
      {
        name: "First Name",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "first_name", availableInWebhook: ["checkouts/create", "checkouts/update"] },
        },
      },
      {
        name: "Last Name",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "last_name", availableInWebhook: ["checkouts/create", "checkouts/update"] },
        },
      },
      {
        name: "Phone",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "phone", availableInWebhook: ["checkouts/create", "checkouts/update"] },
        },
      },
      {
        name: "Province",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "province", availableInWebhook: ["checkouts/create", "checkouts/update"] },
        },
      },
      {
        name: "Province Code",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "province_code", availableInWebhook: ["checkouts/create", "checkouts/update"] },
        },
      },
      {
        name: "ZIP Code",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "zip", availableInWebhook: ["checkouts/create", "checkouts/update"] },
        },
      },
    ],
    syncDisabled: true,
    syncConfig: {
      type: "webhook_only",
    },
  },
};

export const ShopifyShippingAddress = ({
  apiVersion,
  frameworkVersionConstraint,
}: {
  apiVersion: ShopifyApiVersion;
  frameworkVersionConstraint?: string;
}) => buildConnectionSpec(specs, apiVersion, frameworkVersionConstraint);
